// Import Core
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// import { Link } from 'gatsby';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
// Import Utils
import useTablet from '../../../utils/useTablet';
import useMobile from '../../../utils/useMobile';
import { calculateOpeningTimes } from '../../../utils/datetime/calculateOpeningTimes';
// Import configData
import configData from '../../../../configData.json';
import useTodayOpeningOverride from '../../../hooks/useTodayOpeningOverride';
import useOpeningTimesMessage from '../../../hooks/useOpeningTimesMessage';

const MobileBannerStyling = styled.div`
	background-color: var(--blue-10);
	padding: 8px 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	display: none;
	border-top: 1px solid var(--neutral-10);
	padding-top: 12px;
	gap: 4px;
	position: sticky;
	z-index: 998;
	.phone {
		* {
			color: var(--blue);
			font-size: 18px;
		}
	}
	.open {
		color: var(--red);
		position: relative;
		cursor: pointer;
	}

	.hours-dropdown {
		position: relative;
		.dropdown-header {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
			cursor: pointer;
		}
		.dropdown-body {
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);
			margin-top: 6px;
			background: var(--white);
			box-shadow: var(--box-shadow-small);
			width: 100vw;
			z-index: 10;
			display: none;
			&.open {
				display: block;
			}
			.dropdown-title {
				padding: 20px 20px 12px;
				color: var(--red);
				text-align: center;
			}
			.dropdown-item {
				padding: 8px 20px;
				color: var(--neutral-75);
				justify-content: space-between;
				display: flex;
			}
		}
	}

	@media (max-width: 992px) {
		display: flex;
	}
`;

const MobileBanner = ({ className}) => {

	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const {hours} = useTodayOpeningOverride();
    const displayOpen = useOpeningTimesMessage({ hours });


	const { isTablet } = useTablet();
	const { isMobile } = useMobile();

	const formatTime = (timeString) => {
		if (!timeString || typeof timeString !== 'string') return '';
		const parts = timeString.split(':');
		const hours = parseInt(parts[0], 10);
		const minutes = parts[1] || '00';
		const hoursPadded = hours.toString().padStart(2, '0');
		const minutesPadded = minutes.padStart(2, '0');
		return `${hoursPadded}:${minutesPadded}`;
	};

	const formatDate = (dateString) => {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-GB', { 
			weekday: 'long',
			day: 'numeric', 
			month: 'long'
		});
	};

	const formatHours = (hourItem) => {
		if (!hourItem.startHour && !hourItem.endHour) {
			return 'Closed';
		}
		if (!hourItem.startHour || !hourItem.endHour) {
			return '';
		}
		return `${formatTime(hourItem.startHour)} - ${formatTime(hourItem.endHour)}`;
	};

	const hasHours = hours && hours.hours && Array.isArray(hours.hours) && hours.hours.length > 0;

	const toggleDropdown = () => {
		setIsDropdownOpen(!isDropdownOpen);
	};

	// Calculate height for hamburger
	const handleResize = () => {
		const height = document.getElementsByTagName('header')[0].clientHeight;

		if (isTablet || isMobile) {
			document.querySelectorAll('.mobile-banner')[0].style.top = height + 'px';
		}
	};
	useEffect(() => {
		handleResize();
		window.addEventListener('resize', handleResize, false);
	}, [isTablet, isMobile]);

	return (
		<MobileBannerStyling className={className}>
			<div className='phone'>
				<a href={configData.enquiry.phone.link}>
					<p>{configData.enquiry.phone.alt_text}</p>
				</a>
			</div>

			<div className='open'>
				{hasHours ? (
					<div className='hours-dropdown'>
						<div className='dropdown-header' onClick={toggleDropdown}>
							<span className='small'>{displayOpen}</span>
							{isDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
						</div>
						<div className={`dropdown-body ${isDropdownOpen ? 'open' : ''}`}>
							{hours.title && (
								<div className='dropdown-title'>{hours.title}</div>
							)}
							{hours.hours.map((hourItem, index) => (
								<div key={index} className='dropdown-item'>
									<span>{formatDate(hourItem.date)}</span> <span>{formatHours(hourItem)}</span>
								</div>
							))}
						</div>
					</div>
				) : (
					<p className='small'>{displayOpen}</p>
				)}
				{/* Temp to show easter opening times */}
				{/* <p><Link to="/easter-opening-times">Easter Opening Times</Link></p> */}
			</div>
		</MobileBannerStyling>
	);
};

export default MobileBanner;
